import React, {ReactElement} from "react";
import {Accordion, AccordionDetails, AccordionSummary, Box, Chip, styled, Typography} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {ICareerProject} from "../../types/ICareerProject";

const StyledAccordion = styled(Accordion)(({theme}) => ({
    width: '100%',
    marginTop: theme.spacing(2),
    borderRadius: 12, // todo
    borderColor: 'transparent',
    '&:before': {
        height: '0px'
    },
    [theme.breakpoints.only('xs')]: {
        marginLeft: `${theme.spacing(2)} !important`,
    },
    [theme.breakpoints.up('sm')]: {
        marginLeft: `${theme.spacing(8)} !important`,
    },
}));

const StyledChip = styled(Chip)(({theme}) => ({
    borderRadius: 8, // todo
    fontWeight: 'bold',
    fontSize: 14,
    color: theme.palette.text.secondary,
    boxShadow: '2px 2px 0px #00000042',
}));

interface IProps {
    careerProject: ICareerProject;
    isExpanded: boolean;
    wasExpanded: boolean;
    onToggle: () => void;
}

function CareerProjectAccordion({careerProject: project, isExpanded, wasExpanded, onToggle}: IProps): ReactElement {
    const canBeExpanded = project.description && project.description !== '';

    const handleToggle = () => {
        if (!canBeExpanded) {
            return;
        }

        onToggle();
    }
    return (
        <StyledAccordion
            id={'CareerProjectAccordion'}
            square={true}
            expanded={isExpanded}
            onChange={handleToggle}

        >
            <AccordionSummary
                expandIcon={canBeExpanded ? <ExpandMoreIcon/> : undefined}
                id={`CareerProjectSummary`}
            >
                <Box sx={{flexGrow: 1}}>
                    <Typography id='CareerProjectHeader' variant="h6" color="text.tertiary">{project.subHeader}</Typography>
                    <Typography id='CareerProjectHeader' variant="subtitle1" color="text.tertiary" fontSize={22} >{project.header}</Typography>
                    <Typography id='CareerProjectDate' variant="subtitle1" color="text.tertiary">{project.date}</Typography>
                </Box>
            </AccordionSummary>

            {canBeExpanded && (isExpanded || wasExpanded) ?
                <AccordionDetails
                    id='CareerProjectAccordionDetails'
                    sx={{
                        borderRadius: 2,
                    }}
                >
                    <Typography
                        id='CareerProjectDescription'
                        color="text.tertiary"
                        sx={{
                            whiteSpace: 'pre-wrap',
                        }}
                    >
                        {project.description}
                    </Typography>
                    <br/>
                    {
                        project.bulletPoints.map((bulletPoint) =>     <Typography
                            id='CareerProjectDescription'
                            color="text.tertiary"
                            sx={{
                                whiteSpace: 'pre-wrap',
                            }}
                        >
                            • {bulletPoint}
                        </Typography>)
                    }
                    <Box
                        id='CareerProjectSkills'
                        sx={{
                            display: 'flex',
                            flexFlow: 'wrap',
                            paddingTop: 3,
                            gap: 1,
                        }}
                    >
                        {
                            project.skills.map((skill) => (
                                <StyledChip
                                    key={skill}
                                    color={'primary'}
                                    label={skill}
                                />
                            ))
                        }
                    </Box>
                </AccordionDetails> : null
            }
        </StyledAccordion>
    );

}

export default CareerProjectAccordion;
